import { memo } from 'react';

import DocumentsIconSVG from '@/assets/documents-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDocumentsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DocumentsIconSVG} {...props} />;

export const DocumentsIcon = memo(IDocumentsIcon) as typeof IDocumentsIcon;
